module.exports = __webpack_public_path__ + "img/ic_liveticker_card_red.118d1eb6.svg";